import React from 'react'
import Terminal from 'react-console-emulator'
import { Typewriter } from 'react-simple-typewriter'


const commands = {
	whoami: {
		description: "Qui suis-je 🙋.",
		fn: () => {
			return (`Je suis né en Argentine l'anné 1992. J'ai poursuivi mes études de droit à l'Universidad Católica Argentina où j'ai obtenu mon diplôme en 2017.\n
							 Pendant que je faisait mes études et aprés les avoir fini, j'ai travaillé dans des cabinets privés, ainsi que dans des bureaux publics. Et j'en ai eu ma claque. Bosser et s'épanouir en tant que jeune avocat diplômé était une expérience cauchemardesque (les jeunes diplômés comprendront de quoi je parle 🤦).\n 
							 En 2019 j'ai donc démissioné de mon poste et je suis parti pour la France avec un visa du programme « vacances et travail » 🇫🇷. Ça a été la meilleure expérience de ma vie... jusqu'au moment où la COVID a frappé de plein fouet 🦠😷.  \n
							 À cause de la pandémie, j'ai dû retourner en Argentine en décembre 2020. J'étais au chômage et, ayant résolu de ne plus bosser en tant qu'avocat 🙅, je me suis tourné vers les sciences informatiques, notamment le développement web 🖥️.\n
							 J'ai toujours été quelqu'un de trés curieux et qui s'intéresse à comprendre ce que ne m'est pas évident, voire les ordinateurs par example. "Alors pourquoi pas m'y mettre et essayer, histoire de voir jusqu'où je peux aller?". Dans le pire de cas, je finirais par apprendre quelque chose de nouveau 🤓😆.\n
							 J'ai donc commencé de façon autodidacte, et quand j'ai eu vent du cours intensif de Soy Henry sur développement web, je me suis inscrit, j'ai eu mon diplôme et j'ai adoré chaque jour j'y suis passé (4 mois géniales). En plus d'apprendre la programmation web, j'ai traivaillé en tant que Teaching Assistant 🧑‍🏫. Je dois avouer que ceci a éte l'un des meilleures décisions que j'ai prise jusqu'à maintenant. \n 
							 Désormais, je suis développeur web full stack à plein-temps 🧑‍💻, et j'aime trop. Je ne me vois vraiment pas en travaillant d'autre chose puisque c'est tellement cool 😎, et cela ne fait que commencer 🚀.`)
		}
	},
	projects: {
		description: "Quelques projects sur lesquelles j'ai travaillé 🦾.",
		fn: () => {
			return (`✅ "Changas" 👷 - Site internet: https://changas.vercel.app/ \n
			
			'Changas' est une SPA qui réuni l'offre et la demande du personnel non proffesionel (semblable a Indeed et Monster, mais encore mieux). 
			Project sur Github --> https://github.com/mmiglioranza22/Changas \n
			
			✅ "Food recipes" 🍔 - Site internet: https://recipes-spa-project.vercel.app/ \n
			Ceci fut mon premier project! Il a été un devoir sollicité dans le bootcamp de Henry. Vous y trouverez des recettes de cuisine!
			Project sur Github --> https://github.com/mmiglioranza22/recipes_SPA_project`

			)
		}
	},
	contact: {
		description: "Comment se mettre en contact avec moi 📫.",
		fn: () => {
			return (`Voici où et comment me trouver / contacter 👇:\n
							 Email: 		mmiglioranza22@gmail.com
							 LinkedIn:	https://www.linkedin.com/in/manuel-miglioranza-dev/
							 GitHub: 		https://github.com/mmiglioranza22
							 `)
		}
	},
	tellmeajoke: {
		description: 'Les pires des blagues nulles se trouvent ici 🙃. ',
		fn: () => {
			const arr = [
				`C'est l'histoire de la fesse droite, qui dit a la fesse gauche: \n- Ça sent mauvais dans le couloir!`,
				`Tu connais schling-schling la girafe? \nC'est une girafe qui passe trop près d'sun helico et schling-schling la girafe.`,
				`- Comment appelle-t-on les parents de l'homme invisible? \n- Les transparents.`,
				`2 vaches discutent :\n- Ça te fait pas peur toi ces histoires de "vache folle" ?\n+ Ben j'm'en fous j'suis un lapin.`,
				`- Combien il faut de psy pour changer une ampoule ? \n- Un seul mais il faut que l’ampoule veuille vraiment changer.`,
				`- Comment appelle-t-on un chien qui n'as pas des quatre pattes? \n- On ne l'appelle pas, on va le chercher.`,
				`- Comment appelle-t-on un chat tout-terrain ?\n- Un Cat-cat.`,
				`- Quel super héros donne le plus vite l’heure ?\n- Speed heure man.`,
				`- Qu’est-ce qui court et qui se jette ?\n- Une courgette.`,
				`- Qu'est-ce qui est petit et marron ?\n- Un marron !`,
				`- Qu'est-ce qui est noir, blanc, noir, blanc et rouge? \n- Un pingouin qui tombe dans les escaliers.`,
				`- Que font les dinosaures quand ils n'arrivent pas à se mettre d'accord?\n- Un tirage-au-saure !`,
				`- Tu connais la différrence entre un micro-ondes et un séquoia?\n- Moi non plus...`,
				`C'est l'histoire d'un gars qui est tellement petit que sa tête elle pue des pieds.`,
				`- Qu'est-ce qu'une baguette avec une boussole ?\n - Du pain perdu.`,
				`- Comment appelle-t-on une frite enceinte?\n-  Un pomme-de-terre sautée.`,
				`- De quelle couleur est la voiture de John Travolta?\n- Elle est Grease!`,
				`J'ai un poisson qui peut faire du break-dance, mais seulement por dix secondes et que une seule fois.`
			]
			const i = Math.floor((Math.random() * arr.length))
			return arr[i]
		}
	},
}

export default function French() {
	return (
		<div id="container" style={{ display: "flex", justifyContent: "center", alignItems: "center", marginTop: "10px" }}>
			<Terminal

				commands={commands}
				welcomeMessage={
					<Typewriter
						words={[`Salut 👋! \n
											  Je m'appelle Manuel Miglioranza et je suis développeur web full stack 🧑‍💻.
												Si vous désirez me connaître d'avantage, ou bien vous renseigner sur mon travail, vous pourrez le faire à l'aide de cette console-ci. \n
												Pianotez "help" pour afficher les commandes et "clear" pour effacer les messages 😁.`]}
						loop={1}
						cursor
						cursorStyle=''
						typeSpeed={20}
						delaySpeed={50}
					/>}
				promptLabel={'~$'}
				style={{ width: "50%", height: "700px", borderRadius: "3px", backgroundColor: "#1E1E1E", }}
				contentStyle={{ fontSize: "17px", color: "#f153f1", borderRadius: "3px", backgroundColor: "#1E1E1E" }}
				inputAreaStyle={{ color: "#22ff59", paddingBottom: "0px", marginBottom: "0px" }}
				promptLabelStyle={{ color: "#22ff59", paddingBottom: "0px", marginBottom: "0px" }}
				inputTextStyle={{ color: "timberwolf", fontSize: "17px", paddingTop: "2px", marginTop: "6px", marginBottom: "4px" }}
				messageStyle={{ color: "white", marginTop: "4px", marginBottom: "4px", paddingTop: "2px", paddingBottom: "2px" }}
			/>


		</div>
	)
}
